import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { MissingDisputesModel } from "../models/commission/missingdisputes.model";
import { CustomHttpRespone } from "../models/customhttpresponse/custom-http-response";
import { AuthGaurdService } from "./auth-gaurd.service";
import { LoggerService } from "./logger.service";

@Injectable({
    providedIn: 'root'
})
export class MissingDisputesService {

    private host = environment.apiUrl + "missingdisputes";
    public loggedinUser: string = '';

    constructor(private http: HttpClient, private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        if (this.loggedinUser == "" || this.loggedinUser == null) {
            this.loggedinUser = "NA"
        } else {
            this.loggedinUser = this.authGaurdService.loginUser();
        }
    }

    public getKpiList(commplanid: number): Observable<MissingDisputesModel[]> {
        return this.http.get<MissingDisputesModel[]>(`${this.host}/getkpilist/` + commplanid);
    }

    public getMissingDisputesList(): Observable<MissingDisputesModel[]> {
        return this.http.get<MissingDisputesModel[]>(`${this.host}/getmissingdisputeslist`);
    }

    public insertMissingDispute(formData: FormData): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/insertmissingdisputes`, formData);
    }

    public createForm(missingDisputesModel: MissingDisputesModel): FormData {
        const formData = new FormData();

        formData.append('kpi_id', missingDisputesModel.kpi_id.toString());
        formData.append('comm_plan_id', missingDisputesModel.comm_plan_id.toString());
        formData.append('cust_id', missingDisputesModel.cust_id.toString());
        formData.append('corp', missingDisputesModel.corp.toString());
        formData.append('house', missingDisputesModel.house.toString());
        formData.append('revenue', missingDisputesModel.revenue.toString());
        formData.append('wordate', missingDisputesModel.wordate.toString());
        formData.append('wfindate', missingDisputesModel.wfindate.toString());
        formData.append('message', missingDisputesModel.message.toString());
        formData.append('sales_rep_id', missingDisputesModel.sales_rep_id.toString());
        formData.append('currentUser', this.loggedinUser);
        return formData;
    }

    public insertMissingDisputeStatic(missingDisputesModel: MissingDisputesModel): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/insertmissingdisputesstatic`, missingDisputesModel);
    }

    public createMissingForm(missingDisputesModel: MissingDisputesModel): FormData {
        const formData = new FormData();

        formData.append('kpi_id', missingDisputesModel.kpi_id.toString());
        formData.append('message', missingDisputesModel.message.toString());
        // formData.append('message', missingDisputesModel.sc_emp_id.toString());
        // formData.append('message', missingDisputesModel.calRunId.toString());
        formData.append('currentUser', this.loggedinUser);
        return formData;
    }

}